module.exports = __webpack_public_path__ + "fonts/SofiaProRegular-Italic.6cab1857.eot";